import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api, authApis, candidateApi } from "../../config/api";
import { toast } from "react-toastify";

// Async thunk for get post requirement
export const getPostRequirement = createAsyncThunk(
  "all/postrequirement",
  async (reqQueryString, { rejectWithValue }) => {
    try {
      const response = await api.get(`/req/job/get/?${reqQueryString}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for create post requirement
export const createPostRequirement = createAsyncThunk(
  "create/postrequirement",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post("/req/job/create/", userData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update post requirement
export const updatePostRequirement = createAsyncThunk(
  "update/postrequirement",
  async ({ cleanedValues, jobId }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/req/job/update/${jobId}/`,
        cleanedValues
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get search requirement data
export const getRequirementSearchResult = createAsyncThunk(
  "get/searchrequirement",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await candidateApi.get(
        "/resume/profile/search/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const chnageStatusOfCandidate = createAsyncThunk(
  "change/candidate/status",
  async ({ userData, id }, { rejectWithValue }) => {
    try {
      const response = await api.patch(
        `/req/requirements/update-submission/${id}/`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get post requirement
export const getRequirementCandidates = createAsyncThunk(
  "get/requirement-candidate",
  async (userID, { rejectWithValue }) => {
    try {
      // const response = await api.get(`/req/job/get/${userID}/`);
      const response = await api.get(`/req/job/get/${userID}/?interviews=True`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for change status of candidate
export const changeStatusJob = createAsyncThunk(
  "change/job-status",
  async ({ userData, userID }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/req/job/update-shortlisted-resume/${userID}/`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get search requirement data
export const sortlistCandidate = createAsyncThunk(
  "sortlist/candidate",
  async ({ userData, userID }, { rejectWithValue }) => {
    try {
      const response = await api.post(
        `/req/job/resume-shortlist/${userID}/`,
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for multiShortListcandidate
export const multiSortlistCandidate = createAsyncThunk(
  "multi/sortlist/candidates",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        // "/req/job/multi-resume-shortlist/",
        "/req/job/mass-mail/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const multiSortlistCandidateInternal = createAsyncThunk(
  "multi/sortlist/candidates/tracker",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/req/job/mass-mail-to-profile-tracker-candidate/",
        userData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for update post requirement
export const UpdateAction = createAsyncThunk(
  "update/action",
  async ({ updatedValues, jobId }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/req/job/update/${jobId}/`,
        updatedValues
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCandidateSearchDetails = createAsyncThunk(
  "candidate/internal-tracker",
  async (queryString, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await candidateApi.get(
        `/candidate/resume/profile/search/?${queryString}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getUserCountApi = createAsyncThunk(
  "candidate/user_count",
  async (_, { rejectWithValue }) => {
    try {
      // Use the query string directly in the API call
      const response = await authApis.get(
        "auth/user/count/?role=BENCH_SALES_RECRUITER&verification_status=VERIFIED"
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for get all filter Candidate
export const getFilterCandidateForRequirement = createAsyncThunk(
  "get/filter-candidate",
  async ({ job_ID, query }, { rejectWithValue }) => {
    try {
      const response = await api.get(
        `/req/job/${job_ID}/internal-candidate-matches/?${query}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for send mail to candidate
export const sendjobToCandidate = createAsyncThunk(
  "send/job-candidate",
  async (bodyData, { rejectWithValue }) => {
    try {
      const response = await api.post(
        "/req/job/internal-candidate-resume-shortlist/",
        bodyData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const postRequirementSlice = createSlice({
  name: "postrequirement",
  initialState: {
    data: null,
    searchData: null,
    candidateData: null,
    requirementRecentData: null,
    candidateSearchData: null,
    userCountData: null,
    filterCandidate: null,
    status: "idle",
    candidateStatus: "idle",
    error: null,
  },
  reducers: {
    resetStatus: (state) => {
      state.status = "idle"; // Reset the status back to "idle"
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(getPostRequirement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPostRequirement.fulfilled, (state, action) => {
        state.status = "get_all_post_requirement";
        state.data = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getPostRequirement.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(createPostRequirement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(createPostRequirement.fulfilled, (state, action) => {
        state.status = "create_requirement_post";
        state.requirementRecentData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(createPostRequirement.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(updatePostRequirement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updatePostRequirement.fulfilled, (state, action) => {
        state.status = "update_requirement_post";
        toast.success(action.payload?.message);
      })
      .addCase(updatePostRequirement.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getRequirementSearchResult.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getRequirementSearchResult.fulfilled, (state, action) => {
        state.status = "get_search_requirement";
        state.searchData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getRequirementSearchResult.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(chnageStatusOfCandidate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(chnageStatusOfCandidate.fulfilled, (state, action) => {
        state.status = "change_candidate_status";
        toast.success(action.payload?.message);
      })
      .addCase(chnageStatusOfCandidate.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getRequirementCandidates.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(getRequirementCandidates.fulfilled, (state, action) => {
        state.candidateStatus = "get_all_candidate_requirement";
        state.candidateData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getRequirementCandidates.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(changeStatusJob.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(changeStatusJob.fulfilled, (state, action) => {
        state.candidateStatus = "change_candidate_status";
        toast.success(action.payload?.message);
      })
      .addCase(changeStatusJob.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(sortlistCandidate.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(sortlistCandidate.fulfilled, (state, action) => {
        state.candidateStatus = "candidate_sortlisted_succesfully";
        toast.success(action.payload?.message);
      })
      .addCase(sortlistCandidate.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(multiSortlistCandidate.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(multiSortlistCandidate.fulfilled, (state, action) => {
        state.candidateStatus = "candidates_sortlisted_succesfully";
        toast.success(action.payload?.message);
      })
      .addCase(multiSortlistCandidate.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(multiSortlistCandidateInternal.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(multiSortlistCandidateInternal.fulfilled, (state, action) => {
        state.candidateStatus = "candidates_sortlisted_succesfully";
        toast.success(action.payload?.message);
      })
      .addCase(multiSortlistCandidateInternal.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(UpdateAction.pending, (state) => {
        state.candidateStatus = "loading";
      })
      .addCase(UpdateAction.fulfilled, (state, action) => {
        state.candidateStatus = "update_action";
        toast.success(action.payload?.message);
      })
      .addCase(UpdateAction.rejected, (state, action) => {
        state.candidateStatus = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getCandidateSearchDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getCandidateSearchDetails.fulfilled, (state, action) => {
        state.status = "candidate_search_succed";
        state.candidateSearchData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getCandidateSearchDetails.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })
      .addCase(getUserCountApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getUserCountApi.fulfilled, (state, action) => {
        state.status = "get_userCount_success";
        state.userCountData = action.payload;
        // toast.success(action.payload?.message);
      })
      .addCase(getUserCountApi.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(getFilterCandidateForRequirement.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getFilterCandidateForRequirement.fulfilled, (state, action) => {
        state.status = "get_filter_candidate_success";
        state.filterCandidate = action.payload;
      })
      .addCase(getFilterCandidateForRequirement.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      })

      .addCase(sendjobToCandidate.pending, (state) => {
        state.status = "loading";
      })
      .addCase(sendjobToCandidate.fulfilled, (state, action) => {
        state.status = "send_job_candidate_success";
        state.filterCandidate = action.payload;
      })
      .addCase(sendjobToCandidate.rejected, (state, action) => {
        state.status = "failed";
        toast.error(action.payload?.message);
      });
  },
});

export default postRequirementSlice.reducer;
